var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-upload',{attrs:{"action":"#","accept":".zip","show-file-list":false,"http-request":_vm.uploadBtn}},[_c('el-button',{attrs:{"size":"small","loading":_vm.uploadLoading,"type":"primary"}},[_vm._v("上传语料")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }